/**
 * class for a related document
 */

export interface RelatedDocument {
  documentId: string;
  name: string;
}
